import { AbstractControl } from "@angular/forms"

export function ipAddressValidator(control: AbstractControl) {
    const IP_ADDRESS_REGEX = /^(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})$/g
    if (!!control.value) {
        const value = control.value as string;
        const parts = value.split(".");
        const eachPartValid = parts.every((part) => {
            return parseInt(part) >= 0 && parseInt(part) <= 255
        })

        if (parts.length !== 4) {
            return { "invalid": true }
        }
        if (!eachPartValid) {
            return { "invalid": true }
        }


        if (!value.match(IP_ADDRESS_REGEX)) {
            return { "invalid": true }
        } else {
            return null
        }
    } else {
        return { "invalid": true }
    }

}